export default __webpack_public_path__ + "static/media/6-Pre-Listing-Selling Process.2f4417e8.png";